import { render, staticRenderFns } from "./AddressSearchField.vue?vue&type=template&id=3bd2bb54&scoped=true"
import script from "./AddressSearchField.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressSearchField.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AddressSearchField.vue?vue&type=style&index=0&id=3bd2bb54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd2bb54",
  null
  
)

export default component.exports